// extracted by mini-css-extract-plugin
export default {"list":"index_list_wS6cQ","img":"index_img_kUANJ"};